import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';

import {
	setModoTela, initForm
} from './usuarioPerfilActions';

class UsuarioPerfilForm extends Component {

	state = {

	}

    componentWillMount() {

    }

    render() {

		let readOnly = this.props.excluir ? 'readOnly' : '';
		
        return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>
						<Row>
							<Field
								name='nome'
								component={LabelAndInput}
								label='Nome' placeholder='Informe o nome'
								cols='12 12 12 12'
								readOnly={readOnly} />

							<Select
								name='departamentos'
								label='Departamentos' placeholder='Informe'
								options={this.props.listaDepartamento}
								multiple
								cols='12 12 12 12'
								readOnly={readOnly}
								value={(this.props.formularioValues.departamentos || [])}
								onChange={value => {
									this.props.initForm({
										...this.props.formularioValues,
										departamentos: (value || []).map(item => parseInt(item.value))
									});
								}} />

							<Grid cols='12 12 12 12'>
								<label style={{ marginBottom: 16 }}>Permissões:</label>
							</Grid>

							<Field 
								maxWidth={120}
								name='acesso_dashboard'
								component={LabelAndCheckbox}
								label='Dashboard' placeholder='Selecione'
								cols='12 6 4 3'
								readOnly={readOnly} />

							<Field 
								maxWidth={180}
								name='acesso_cadastro_usuario'
								component={LabelAndCheckbox}
								label='Acessos de Usuários' placeholder='Selecione'
								cols='12 6 4 3'
								readOnly={readOnly} />
							
							<Field
								maxWidth={160}
								name='acesso_cadastro_departamento'
								component={LabelAndCheckbox}
								label='Departamentos' placeholder='Selecione'
								cols='12 6 4 3'
								readOnly={readOnly} />

							<Field
								maxWidth={130}
								name='acesso_cadastro_cliente'
								component={LabelAndCheckbox}
								label='Cadastros' placeholder='Selecione'
								cols='12 6 4 3'
								readOnly={readOnly} />

							<Field
								maxWidth={200}
								name='acesso_cadastro_checklist'
								component={LabelAndCheckbox}
								label='Configurar Checklists' placeholder='Selecione'
								cols='12 6 4 3'
								readOnly={readOnly} />

							<Field
								maxWidth={270}
								name='acesso_cadastro_modelo_relatorio'
								component={LabelAndCheckbox}
								label='Configurar Modelos de Relatórios' placeholder='Selecione'
								cols='12 6 4 3'
								readOnly={readOnly} />
								
							<Field
								maxWidth={200}
								name='acesso_checklist_resposta_admin'
								component={LabelAndCheckbox}
								label='Administrar Checklists' placeholder='Selecione'
								cols='12 6 4 3'
								readOnly={readOnly} />

							<Field
								maxWidth={200}
								name='acesso_checklist_resposta'
								component={LabelAndCheckbox}
								label='Responder Checklists' placeholder='Selecione'
								cols='12 6 4 3'
								readOnly={readOnly} />
								
							<Field
								maxWidth={200}
								name='acesso_relatorio'
								component={LabelAndCheckbox}
								label='Administrar Relatórios' placeholder='Selecione'
								cols='12 6 4 3'
								readOnly={readOnly} />

							<Field
								maxWidth={200}
								name='acesso_cadastro_modelo_certificado'
								component={LabelAndCheckbox}
								label='Modelo de Certificados' placeholder='Selecione'
								cols='12 6 4 3'
								readOnly={readOnly} />

							<Field
								maxWidth={200}
								name='acesso_emitir_certificado'
								component={LabelAndCheckbox}
								label='Emitir Certificados' placeholder='Selecione'
								cols='12 6 4 3'
								readOnly={readOnly} />

						</Row>
					</ContentCardBody>
					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='6 6 4 3'>
								{this.props.excluir ? (
									<Button
										text='Excluir'
										submit type={'danger'}
										icon={'fa fa-trash'} />
								) : (
								<Button
									text='Salvar'
									submit
									type={'success'}
									icon={'fa fa-check'} />
								)}
							</Grid>
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => window.confirm('Deseja realmente sair dessa tela?') ? this.props.setModoTela('lista') : null} />
							</Grid>
						</Row>
					</ContentCardFooter>
				</Form>
			</ContentCard>
        )
    }


}

UsuarioPerfilForm = reduxForm({form: 'usuarioPerfilForm', destroyOnUnmount: false})(UsuarioPerfilForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	formularioValues: getFormValues('usuarioPerfilForm')(state),
	registro: state.usuarioPerfil.registro,
	listaDepartamento: state.departamento.lista.map(item => ({ id: item.id, valor: item.nome }))
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(UsuarioPerfilForm);
